import jsPDF from 'jspdf';
import QRCode from 'qrcode';

export const generateOfferCardsPDF = async (offers, currency) => {
    const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
    });

    // A4 Dimensionen: 210mm x 297mm
    const pageWidth = 210;
    const pageHeight = 297;

    // Kärtchen Dimensionen (3 Spalten x 4 Reihen pro Seite)
    const cardsPerRow = 3;
    const cardsPerColumn = 4;
    const cardWidth = pageWidth / cardsPerRow;
    const cardHeight = pageHeight / cardsPerColumn;

    // Padding innerhalb des Kärtchens
    const padding = 5;
    const qrSize = 30;

    let cardIndex = 0;

    for (const offer of offers) {
        // Berechne Position auf der Seite
        const row = Math.floor(cardIndex / cardsPerRow) % cardsPerColumn;
        const col = cardIndex % cardsPerRow;

        // Neue Seite wenn nötig
        if (cardIndex > 0 && cardIndex % (cardsPerRow * cardsPerColumn) === 0) {
            pdf.addPage();
        }

        const x = col * cardWidth;
        const y = row * cardHeight;

        // Zeichne Rahmen um das Kärtchen
        pdf.setDrawColor(200, 200, 200);
        pdf.rect(x, y, cardWidth, cardHeight);

        // Generiere QR Code
        try {
            const qrDataUrl = await QRCode.toDataURL(offer.offerCode, {
                width: 200,
                margin: 1
            });

            // QR Code zentriert oben platzieren
            const qrX = x + (cardWidth - qrSize) / 2;
            const qrY = y + padding;
            pdf.addImage(qrDataUrl, 'PNG', qrX, qrY, qrSize, qrSize);

            // Gutschein-Code unter QR
            pdf.setFontSize(10);
            pdf.setFont(undefined, 'bold');
            const codeY = qrY + qrSize + 3;
            pdf.text(offer.offerCode, x + cardWidth / 2, codeY, { align: 'center' });

            // Trennlinie
            pdf.setDrawColor(200, 200, 200);
            pdf.line(x + padding, codeY + 2, x + cardWidth - padding, codeY + 2);

            // Produkte auflisten
            pdf.setFontSize(8);
            pdf.setFont(undefined, 'normal');
            let textY = codeY + 6;

            if (offer.offerSnapshotProducts && offer.offerSnapshotProducts.length > 0) {
                offer.offerSnapshotProducts.forEach((op, index) => {
                    const productText = `${op.count}x ${op?.name || 'Unbekannt'}`;

                    // Text umbrechen wenn zu lang
                    const maxWidth = cardWidth - (padding * 2);
                    const lines = pdf.splitTextToSize(productText, maxWidth);

                    lines.forEach(line => {
                        if (textY < y + cardHeight - padding - 8) { // Platz für Preis lassen
                            pdf.text(line, x + cardWidth / 2, textY, { align: 'center' });
                            textY += 3;
                        }
                    });
                });
            }

            // Preis am unteren Rand
            pdf.setFontSize(11);
            pdf.setFont(undefined, 'bold');
            const priceY = y + cardHeight - padding - 3;
            pdf.text(`${offer.offerPrice.toFixed(2)} ${currency}`, x + cardWidth / 2, priceY, { align: 'center' });

        } catch (error) {
            console.error('Fehler beim Generieren des QR Codes:', error);
        }

        cardIndex++;
    }

    // PDF speichern
    const timestamp = new Date().toISOString().split('T')[0];
    pdf.save(`Gutscheine_${timestamp}.pdf`);
};